module.exports = __webpack_public_path__ + "img/soc.6930bb76.png";